import { WithdrawFillInput, WithdrawInput } from '@/types/withdraw';
import { filterValueToQuery, camelObjectToSnakeObject } from '@/api';

export default function withdraw(axios: any) {
  async function getWithdraws(filter: any) {
    try {
      const response = await axios.get(`/api/withdraw_requests?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/withdraw] getWithdraws Error', e);
    }
    return null;
  }

  async function getWithdraw(id: number) {
    const response = await axios.get(`/api/withdraw_requests/${id}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/withdraw] getWithdraw Error', e);
    }
    return null;
  }

  async function getWithdrawItems(filter: any) {
    const response = await axios.get(`/api/withdraw_request_items?${filterValueToQuery(filter)}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/withdraw] getWithdrawItems Error', e);
    }
    return null;
  }

  async function createWithdraw(payload: WithdrawInput) {
    const response = await axios.post('/api/withdraw_requests', camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/withdraw] createWithdraw Error', e);
    }
    return null;
  }

  async function updateWithdraw(id: number | string, payload: WithdrawInput) {
    const response = await axios.put(`/api/withdraw_requests/${id}`, camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/withdraw] updateWithdraw Error', e);
    }
    return null;
  }

  async function deleteWithdraw(id: number) {
    const response = await axios.delete(`/api/withdraw_requests/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/withdraw] deleteWithdraw Error', e);
    }
    return null;
  }

  async function updateWithdrawFill(id: number, payload: { items: WithdrawFillInput[], remarks: string }) {
    try {
      const response = await axios.post(`/api/withdraw_requests/${id}/fill`, { items: camelObjectToSnakeObject(payload.items), remarks: payload.remarks });
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-order] updateWithdrawFill Error', e);
      return e;
    }
    return null;
  }

  async function getWithdrawStats(filter: any) {
    const response = await axios.get(`/api/withdraw_requests/stats?${filterValueToQuery(filter)}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/withdraw] getWithdrawStats Error', e);
    }
    return null;
  }

  async function searchWithdrawItems(payload: any) {
    const response = await axios.post('/api/withdraw_request_items/search', payload);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/withdraw] searchWithdrawItems Error', e);
    }
    return null;
  }

  async function updateWithdrawItem(id: number, payload: any) {
    const response = await axios.put(`/api/withdraw_request_items/${id}`, camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/withdraw] updateWithdrawItem Error', e);
    }
    return null;
  }

  return {
    getWithdraws,
    getWithdraw,
    getWithdrawStats,
    getWithdrawItems,
    searchWithdrawItems,
    createWithdraw,
    updateWithdraw,
    updateWithdrawFill,
    deleteWithdraw,

    updateWithdrawItem,
  };
}
